"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchData = void 0;
var _object = require("./type-checks/object");
var _string = require("./type-checks/string");
/**
 * Utility method to make asynchronous GET and PUT requests
 *
 * @name fetchData
 * @param {String} location URL of resource retreiving
 * @param {Object} options optional configuration options
 * @param {Object} data Data Object to send (in post)
 * @param {Boolean} options.isBlob Indicates Blob format for response
 * @param {Boolean} options.isFormData Indicates FormData format for response
 * @param {Boolean} options.isJson Indicates JSON format for response
 * @param {Boolean} options.isResponseObject Indicates return of entire response object
 * @param {Boolean} options.isText Indicates text format for response (default response format)
 * @param {String} options.method Method indicator, either "get" or "post" (defaults to GET)
 * @returns {Promise<any>} promise returning desired result
 */
const fetchData = async (location, options) => {
  const configOptions = (0, _object.isObject)(options) ? options : {};
  let headers = (0, _string.isStringOfLength)(configOptions.method) && configOptions.method.toUpperCase() === "POST" ? {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "method": "POST",
    "body": (0, _object.isObject)(configOptions.data) ? configOptions.data : null
  } : {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "method": "GET"
  };
  return fetch(location, {
    "headers": headers
  }).then(response => {
    let result;
    if (configOptions.isJson === true) {
      result = response.json();
    } else if (configOptions.isBlob === true) {
      result = response.blob();
    } else if (configOptions.isFormData === true) {
      result = response.formData();
    } else if (configOptions.isResponseObject === true) {
      result = response;
    } else {
      result = response.text();
    }
    return result;
  });
};
exports.fetchData = fetchData;